import { useCallback, useState } from "react";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import FormButton from "./button";
import FormButtonV2 from "./button-v2";
import FormContent from "./content";
import { isProduction } from "../../../../../../helper/util";

const ItRepairToolInformation = () => {
  /**
   * Form states
   */
  const [assignList, setAssignList] = useState<any>([]);
  const [selectedITHead, setSelectedITHead] = useState(null as any);
  const [assignee, setAssignee] = useState(null as any);

  const onApproverChange = useCallback((selectedOptions: any) => {
    setAssignee(selectedOptions ? selectedOptions : null);
  }, []);

  const onEmployeeChange = useCallback((selectedOptions: any) => {
    const assignedList = selectedOptions?.target?.selectedPeople;
    setAssignList(assignedList);
    setSelectedITHead(
      selectedOptions?.target?.selectedPeople && selectedOptions?.target?.selectedPeople[0]
    );
  }, []);


  const onAssignedChange = useCallback((selectedOptions: any) => {
    const assignedList = selectedOptions?.target?.selectedPeople;
    setAssignList(assignedList);
    setAssignee(
      selectedOptions?.target?.selectedPeople && selectedOptions?.target?.selectedPeople[0]
    );
  }, []);

  return (
    <InformationLayout>
      <Box title="Thông tin sửa chữa CNTT" className="full-height">
        <FormContent
          assignee={assignee}
          onEmployeeChange={onEmployeeChange}
          onApproverChange={onApproverChange}
          onAssignedChange={onAssignedChange}
        />
        {isProduction ?
          <FormButton assignList={assignList} assignee={assignee} selectedITHead={selectedITHead} />
          :
          <FormButtonV2 assignList={assignList} assignee={assignee} selectedITHead={selectedITHead} />
        }
      </Box>
    </InformationLayout>
  );
};

export default ItRepairToolInformation;
